import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-form-consent__button__wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["p-form-consent", {
      'p-form-consent--side_menu': _ctx.sideMenu
    }])
  }, [
    _cache[1] || (_cache[1] = _createElementVNode("p", { class: "p-form-consent__heading" }, "個人情報同意確認", -1)),
    _cache[2] || (_cache[2] = _createElementVNode("p", null, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("p", { class: "p-form-consent__lead" }, " 個人情報の利用に関して下記リンクの利用規約をご参照のうえ、ご同意いただける場合は「利用規約に同意する」ボタンをクリックしてください。利用規約は必ずお読みいただけるようにお願い申し上げます。 ", -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("a", {
        href: "https://bs.benefit-one.co.jp/BE-ONE/official/handling.html",
        target: "_blank",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.link_clicked && _ctx.link_clicked(...args))),
        class: "p-form-consent__button"
      }, "利用規約")
    ]),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ], 2))
}